import { TV2M_INSTALL_REF_PARAM, parseQrInstallRef, parseTv2mDeepLink, } from '@apm/contracts';
/**
 * 진입 URL 하나에서 **라우팅 결정 하나**를 낸다.
 *
 * `@apm/contracts` 의 `parseTv2mDeepLink` 와 `parseQrInstallRef` 는 각각 다른 것을 읽는다.
 * 그 둘을 화면이 직접 부르면 **우선순위를 화면마다 다시 정하게 되고**, 앱에는 진입점이
 * 넷이다(`/`, `/tv2m/product`, `/install`, `/done`). 우선순위는 하나뿐이므로 코어가 정한다.
 *
 * `parseTv2mDeepLink` 가 경로를 검사하지 않는 것과 같은 이유로 여기서도 검사하지 않는다 —
 * 네이티브 포팅 시 베이스가 커스텀 스킴으로 바뀌면 경로에 기댄 판정이 웹 전용이 된다.
 */
export function resolveRoute(url) {
    // **Deep Link 가 먼저다.** 둘 다 실려 있으면 상품으로 바로 간다 — Deep Link 는 어느
    // 상품인지를 이미 담고 있고, 설치 ref 는 "나중에 서버에 물어보면 알 수 있다" 는 약속이다.
    // 알고 있는 쪽을 두고 물어보러 가면 왕복 한 번과 실패 가능성을 공짜로 얻는다.
    const context = parseTv2mDeepLink(url);
    if (context)
        return { kind: 'product', context };
    const sessionToken = extractInstallRef(url);
    if (sessionToken)
        return { kind: 'install', sessionToken };
    return { kind: 'none' };
}
/**
 * `?ref=tv2m_qr_{token}` 에서 세션 토큰을 뽑는다. 우리가 낸 값이 아니면 `null`.
 *
 * 판별은 `parseQrInstallRef` 가 한다 (`ref` 는 마케팅 유입 값으로 이미 흔하다).
 * 여기가 하는 일은 URL 에서 그 파라미터를 꺼내는 것뿐이다.
 */
export function extractInstallRef(url) {
    return parseQrInstallRef(readParam(url, TV2M_INSTALL_REF_PARAM));
}
/**
 * Deep Link 의 목적지가 우리가 아는 상품인지 확인하고 컨텍스트를 준다.
 * `resolveRoute` 를 거치지 않고 Push 알림의 `deep_link_url` 을 직접 읽는 경로용이다.
 */
export function parseDeepLink(url) {
    return parseTv2mDeepLink(url);
}
/**
 * 쿼리에서 값 하나를 읽는다. `URL`·`URLSearchParams` 를 쓸 수 없다 —
 * 코어는 `lib: ES2022` 로 컴파일된다 (`@apm/contracts` 의 `parseQuery` 와 같은 사정).
 *
 * 같은 키가 두 번 오면 앞의 것을 남긴다. 우리가 낸 링크에 덧붙은 값을 신뢰하지 않는다.
 */
function readParam(url, name) {
    const hashAt = url.indexOf('#');
    const withoutFragment = hashAt === -1 ? url : url.slice(0, hashAt);
    const queryAt = withoutFragment.indexOf('?');
    if (queryAt === -1)
        return null;
    for (const chunk of withoutFragment.slice(queryAt + 1).split('&')) {
        if (chunk === '')
            continue;
        const eq = chunk.indexOf('=');
        const key = decodeURIComponent(eq === -1 ? chunk : chunk.slice(0, eq));
        if (key !== name)
            continue;
        return eq === -1 ? '' : decodeURIComponent(chunk.slice(eq + 1));
    }
    return null;
}
//# sourceMappingURL=deep-link.js.map